/* Generated from the normative Carb-Planner prototype. Rebuild with outputs/carb-planner_20260720/build_shopify_theme_files.js. */
(() => {
  "use strict";
"use strict";

    const PUBLIC_MAX_G_PER_HOUR = 90;
    const EXPERT_MAX_TESTED_G_PER_HOUR = 120;
    const SPORT_CAP_MINUTES = Object.freeze({ laufen: 360, rad: 900, trail: 1440, tri: 900 });
    const TOLERANCE_CAPS = Object.freeze({ unknown: 30, tested30: 30, tested45: 45, tested60: 60, tested90: 90 });
    const ALLOWED = Object.freeze({
      sport: ["laufen", "rad", "trail", "tri"],
      context: ["training", "race"],
      intensity: ["locker", "moderat", "hart"],
      toleranceBand: ["unknown", "tested30", "tested45", "tested60", "tested90"],
      conditions: ["kuehl", "mild", "heiss"],
      sweatProfile: ["low", "normal", "high"],
      formats: ["gel", "drink", "chews", "riegel"]
    });
    const TABLE_RATES = Object.freeze({
      "training:locker": [0, 0, 30, 60],
      "training:moderat": [0, 15, 45, 75],
      "training:hart": [0, 30, 60, 90],
      "race:locker": [0, 15, 45, 75],
      "race:moderat": [0, 30, 60, 90],
      "race:hart": [0, 30, 60, 90]
    });
    const HYDRATION_BASE = Object.freeze({
      kuehl: [0.3, 0.5],
      mild: [0.4, 0.7],
      heiss: [0.5, 0.9]
    });
    const LABELS = Object.freeze({
      sport: { laufen: "Laufen", rad: "Rad", trail: "Trail / Ultra", tri: "Triathlon" },
      context: { training: "Training", race: "Wettkampf" },
      intensity: { locker: "Locker", moderat: "Moderat", hart: "Hart" },
      toleranceBand: { unknown: "Noch nicht sicher", tested30: "30 g/h getestet", tested45: "45 g/h getestet", tested60: "60 g/h getestet", tested90: "90 g/h getestet" },
      conditions: { kuehl: "Kühl", mild: "Gemässigt", heiss: "Heiss / schwül" },
      formats: { gel: "Gels", drink: "Drink-Mix", chews: "Chews", riegel: "Energy-Riegel" }
    });
    const CATEGORY_LINKS = Object.freeze({
      gel: Object.freeze({ datasetKey: "collectionGelUrl", fallbackUrl: "https://fuelbox.ch/collections/alle-gels", label: "Gels ansehen" }),
      drink: Object.freeze({ datasetKey: "collectionDrinkUrl", fallbackUrl: "https://fuelbox.ch/collections/sportgetraenke", label: "Sportgetränke ansehen" }),
      chews: Object.freeze({ datasetKey: "collectionChewsUrl", fallbackUrl: "https://fuelbox.ch/collections/chews", label: "Chews ansehen" }),
      riegel: Object.freeze({ datasetKey: "collectionRiegelUrl", fallbackUrl: "https://fuelbox.ch/collections/energie-bars", label: "Energieriegel ansehen" })
    });
    const TEST_PACKAGE_ROLE_ORDER = Object.freeze(["drink", "chew", "long", "starter", "gel", "race", "high_carb", "caffeine_free"]);
    const TEST_PACKAGE_ROLES = Object.freeze({
      starter: Object.freeze({ formats: Object.freeze(["gel", "drink", "chews", "riegel"]), reason: "Alle Formen in einer Box: Gels, Drink-Mix, Riegel und Chews zum Ausprobieren.", badges: Object.freeze(["Format-Mix", "Komplett"]) }),
      gel: Object.freeze({ formats: Object.freeze(["gel"]), reason: "Für den Vergleich unterschiedlicher Gels und Konsistenzen.", badges: Object.freeze(["Gel-Auswahl", "Vergleichen"]) }),
      caffeine_free: Object.freeze({ formats: Object.freeze(["gel"]), reason: "Koffeinfreie Alternative für kontrollierte Trainingstests.", badges: Object.freeze(["Ohne Koffein", "Gel-Auswahl"]) }),
      race: Object.freeze({ formats: Object.freeze(["gel", "chews"]), reason: "Für laufnahe Wettkampftests unter Trainingsbedingungen.", badges: Object.freeze(["Race-Training", "Gel & Chews"]) }),
      high_carb: Object.freeze({ formats: Object.freeze(["gel"]), reason: "Für intensive Einheiten und höhere Kohlenhydratziele.", badges: Object.freeze(["High-Carb", "Race-Training"]) }),
      long: Object.freeze({ formats: Object.freeze(["gel", "drink", "riegel"]), reason: "Für lange Einheiten: Drink-Mix, Gels und Riegel kombiniert.", badges: Object.freeze(["Lange Einheiten", "Format-Mix"]) }),
      chew: Object.freeze({ formats: Object.freeze(["chews"]), reason: "Wenn Chews empfohlen oder persönlich ausgewählt wurden.", badges: Object.freeze(["Chew-Auswahl", "Portionierbar"]) }),
      drink: Object.freeze({ formats: Object.freeze(["drink", "gel"]), reason: "Drink-Mix und Gels kombiniert – unkomplizierter Einstieg.", badges: Object.freeze(["Drink-Mix", "Gels"]) })
    });

    const DEFAULT_STATE = Object.freeze({
      schemaVersion: 2,
      sport: "laufen",
      context: "training",
      durationMinutes: 120,
      intensity: "moderat",
      toleranceBand: "unknown",
      conditions: "mild",
      expertEnabled: false,
      expert: Object.freeze({
        testedCarbRateGph: null,
        exactCarbRateEnabled: false,
        sweatProfile: "normal",
        productFormatMode: "auto",
        selectedProductFormats: Object.freeze([])
      })
    });

    const roundTo5 = value => Math.round(value / 5) * 5;
    const roundTo01 = value => Math.round((value + Number.EPSILON) * 10) / 10;
    const cloneDefaultState = () => ({ ...DEFAULT_STATE, expert: { ...DEFAULT_STATE.expert, selectedProductFormats: [] } });
    const isAllowed = (group, value) => ALLOWED[group].includes(value);
    const isValidTestedRate = value => Number.isInteger(value) && value >= 5 && value <= EXPERT_MAX_TESTED_G_PER_HOUR && value % 5 === 0;

    function validateAndNormalizeInput(raw) {
      const errors = [];
      const input = cloneDefaultState();
      ["sport", "context", "intensity", "toleranceBand", "conditions"].forEach(key => {
        if (!isAllowed(key, raw[key])) errors.push(`INVALID_${key.toUpperCase()}`);
        else input[key] = raw[key];
      });

      const duration = Number(raw.durationMinutes);
      if (!Number.isInteger(duration) || duration < 15 || duration % 15 !== 0 || duration > SPORT_CAP_MINUTES[input.sport]) {
        errors.push("INVALID_DURATION");
      } else input.durationMinutes = duration;

      input.expertEnabled = raw.expertEnabled === true;
      const rawExpert = raw.expert && typeof raw.expert === "object" ? raw.expert : {};
      input.expert.sweatProfile = isAllowed("sweatProfile", rawExpert.sweatProfile) ? rawExpert.sweatProfile : "normal";
      input.expert.exactCarbRateEnabled = rawExpert.exactCarbRateEnabled === true;
      input.expert.testedCarbRateGph = isValidTestedRate(Number(rawExpert.testedCarbRateGph)) ? Number(rawExpert.testedCarbRateGph) : null;
      input.expert.productFormatMode = rawExpert.productFormatMode === "manual" ? "manual" : "auto";
      input.expert.selectedProductFormats = Array.isArray(rawExpert.selectedProductFormats)
        ? [...new Set(rawExpert.selectedProductFormats.filter(value => isAllowed("formats", value)))]
        : [];
      if (input.expertEnabled && input.expert.exactCarbRateEnabled && !input.expert.testedCarbRateGph) errors.push("INVALID_EXACT_CARB_RATE");
      if (input.expertEnabled && input.expert.productFormatMode === "manual" && input.expert.selectedProductFormats.length === 0) errors.push("EMPTY_MANUAL_FORMAT_SELECTION");

      return { ok: errors.length === 0, errors, input };
    }

    function computeTargetRange(durationMinutes) {
      if (durationMinutes < 45) return { min: 0, max: 0, key: "UNDER_45" };
      if (durationMinutes < 75) return { min: 0, max: 30, key: "MIN_45_74" };
      if (durationMinutes < 150) return { min: 30, max: 60, key: "MIN_75_149" };
      return { min: 60, max: 90, key: "MIN_150_PLUS" };
    }

    function blendRate(previousRate, nextRate, duration, boundary, windowMinutes = 30) {
      if (duration <= boundary) return previousRate;
      if (duration >= boundary + windowMinutes) return nextRate;
      const progress = (duration - boundary) / windowMinutes;
      return roundTo5(previousRate + (nextRate - previousRate) * progress);
    }

    function computeTransitionedTableRate(input) {
      const rates = TABLE_RATES[`${input.context}:${input.intensity}`];
      const duration = input.durationMinutes;
      if (duration < 45) return { tableRateGph: rates[0], transitionedTableRateGph: rates[0], inTransition: false };
      if (duration < 75) return { tableRateGph: rates[1], transitionedTableRateGph: blendRate(rates[0], rates[1], duration, 45), inTransition: rates[0] !== rates[1] };
      if (duration < 105) return { tableRateGph: rates[2], transitionedTableRateGph: blendRate(rates[1], rates[2], duration, 75), inTransition: rates[1] !== rates[2] };
      if (duration < 150) return { tableRateGph: rates[2], transitionedTableRateGph: rates[2], inTransition: false };
      if (duration < 180) return { tableRateGph: rates[3], transitionedTableRateGph: blendRate(rates[2], rates[3], duration, 150), inTransition: rates[2] !== rates[3] };
      return { tableRateGph: rates[3], transitionedTableRateGph: rates[3], inTransition: false };
    }

    function getEffectiveToleranceCap(input) {
      const useExpert = input.expertEnabled && input.expert.exactCarbRateEnabled && isValidTestedRate(input.expert.testedCarbRateGph);
      return { capGph: useExpert ? input.expert.testedCarbRateGph : TOLERANCE_CAPS[input.toleranceBand], source: useExpert ? "expert_tested" : "tolerance_band" };
    }

    function computeCarbTarget(input) {
      const range = computeTargetRange(input.durationMinutes);
      const transitioned = computeTransitionedTableRate(input);
      const tolerance = getEffectiveToleranceCap(input);
      const planRateGph = Math.min(transitioned.transitionedTableRateGph, tolerance.capGph, PUBLIC_MAX_G_PER_HOUR);
      const limitedByTolerance = tolerance.capGph < transitioned.transitionedTableRateGph;
      const expertRateStatus = tolerance.source !== "expert_tested"
        ? "unused"
        : input.expert.testedCarbRateGph < transitioned.transitionedTableRateGph
          ? "limits_plan"
          : input.expert.testedCarbRateGph === transitioned.transitionedTableRateGph
            ? "confirms_table_rate"
            : "above_table_rate";
      const expertRateAboveTargetRange = tolerance.source === "expert_tested" && input.expert.testedCarbRateGph > range.max;
      const belowTargetDueToTransition = transitioned.inTransition && transitioned.transitionedTableRateGph < range.min;
      return {
        targetRangeMinGph: range.min,
        targetRangeMaxGph: range.max,
        targetRangeKey: range.key,
        tableRateGph: transitioned.tableRateGph,
        transitionedTableRateGph: transitioned.transitionedTableRateGph,
        effectiveToleranceCapGph: tolerance.capGph,
        toleranceSource: tolerance.source,
        planRateGph,
        publicCapGph: PUBLIC_MAX_G_PER_HOUR,
        inTransition: transitioned.inTransition,
        belowTargetDueToTransition,
        limitedByTolerance,
        expertRateStatus,
        expertRateAboveTargetRange
      };
    }

    function cadenceForRate(planRateGph) {
      if (planRateGph <= 0) return null;
      if (planRateGph <= 20) return 60;
      if (planRateGph <= 60) return 30;
      return 20;
    }

    function distributeCarbs(totalCarbs, intakeCount) {
      if (totalCarbs <= 0 || intakeCount <= 0) return [];
      const totalUnits = Math.round(totalCarbs / 5);
      const baseUnits = Math.floor(totalUnits / intakeCount);
      const extraUnits = totalUnits % intakeCount;
      const units = Array(intakeCount).fill(baseUnits);
      for (let n = 0; n < extraUnits; n += 1) {
        const index = Math.floor((n + 0.5) * intakeCount / extraUnits);
        units[Math.min(index, intakeCount - 1)] += 1;
      }
      return units.map(value => value * 5);
    }

    function computeTimeline(planRateGph, durationMinutes) {
      const rawTotalCarbs = planRateGph * durationMinutes / 60;
      const plannedTotalCarbs = roundTo5(rawTotalCarbs);
      if (planRateGph <= 0 || plannedTotalCarbs <= 0) {
        return { rawTotalCarbs, plannedTotalCarbs: 0, plannedDurationMinutes: durationMinutes, cadenceRuleMinutes: null, actualIntervalMinutes: null, displayIntervalMinutes: null, intakeCount: 0, segmentMinutes: null, intakes: [], equivalent25gUnits: 0 };
      }
      const cadenceRuleMinutes = cadenceForRate(planRateGph);
      const cadenceCount = Math.max(1, Math.ceil(durationMinutes / cadenceRuleMinutes));
      const availableFiveGramUnits = Math.max(1, Math.round(plannedTotalCarbs / 5));
      const intakeCount = Math.min(cadenceCount, availableFiveGramUnits);
      const segmentMinutes = durationMinutes / intakeCount;
      const carbs = distributeCarbs(plannedTotalCarbs, intakeCount);
      const usedDisplayMinutes = new Set();
      const intakes = carbs.map((carbsG, index) => {
        const minuteRaw = segmentMinutes * (index + 0.5);
        let minuteDisplay = Math.round(minuteRaw / 5) * 5;
        while (usedDisplayMinutes.has(minuteDisplay) && minuteDisplay + 5 < durationMinutes) minuteDisplay += 5;
        usedDisplayMinutes.add(minuteDisplay);
        return { minuteRaw, minuteDisplay, carbsG };
      });
      return {
        rawTotalCarbs,
        plannedTotalCarbs,
        plannedDurationMinutes: durationMinutes,
        cadenceRuleMinutes,
        actualIntervalMinutes: segmentMinutes,
        displayIntervalMinutes: Math.round(segmentMinutes / 5) * 5,
        intakeCount,
        segmentMinutes,
        intakes,
        equivalent25gUnits: plannedTotalCarbs / 25
      };
    }

    function computeHydration(input) {
      if (input.durationMinutes < 45) return { mode: "thirst", fluidRateMinLph: null, fluidRateMaxLph: null, fluidTotalMinL: null, fluidTotalMaxL: null, showTotal: false, sodiumGuidance: "NONE", appliedSweatProfile: "normal" };
      const [baseMin, baseMax] = HYDRATION_BASE[input.conditions];
      const profile = input.expertEnabled ? input.expert.sweatProfile : "normal";
      const midpoint = (baseMin + baseMax) / 2;
      const selectedMin = profile === "high" ? midpoint : baseMin;
      const selectedMax = profile === "low" ? midpoint : baseMax;
      const fluidRateMinLph = roundTo01(selectedMin);
      const fluidRateMaxLph = roundTo01(selectedMax);
      const showTotal = input.durationMinutes <= 240;
      return {
        mode: "range",
        baseFluidRateMinLph: baseMin,
        baseFluidRateMaxLph: baseMax,
        fluidRateMinLph,
        fluidRateMaxLph,
        fluidTotalMinL: showTotal ? roundTo01(fluidRateMinLph * input.durationMinutes / 60) : null,
        fluidTotalMaxL: showTotal ? roundTo01(fluidRateMaxLph * input.durationMinutes / 60) : null,
        showTotal,
        sodiumGuidance: input.durationMinutes >= 90 || input.conditions === "heiss" ? "400_700_MG_PER_L" : "NONE",
        appliedSweatProfile: profile
      };
    }

    function computeFormatPlan(input, carbTarget) {
      if (carbTarget.planRateGph <= 0) {
        return {
          defaultFormats: [], recommendedFormats: [], optionalFormats: [], disallowedFormats: [...ALLOWED.formats],
          activeFormats: [], personalFormats: [], personalSelectableFormats: [], productFormatMode: "auto",
          statusByFormat: Object.fromEntries(ALLOWED.formats.map(value => [value, "blocked"]))
        };
      }

      const recommended = new Set(["gel", "drink"]);
      const optional = new Set();
      const hard = input.intensity === "hart";

      if (hard) optional.add("chews");
      else recommended.add("chews");

      if (input.sport === "rad" && input.durationMinutes >= 90) {
        (hard ? optional : recommended).add("riegel");
      } else if (input.sport === "trail" && input.durationMinutes >= 120) {
        (hard ? optional : recommended).add("riegel");
      } else if (input.sport === "tri" && input.durationMinutes >= 90) {
        optional.add("riegel");
      } else if (input.sport === "laufen" && input.durationMinutes >= 120 && input.intensity === "locker") {
        optional.add("riegel");
      }

      recommended.forEach(value => optional.delete(value));
      const recommendedFormats = [...recommended];
      const optionalFormats = [...optional];
      const allowedFormats = [...new Set([...recommendedFormats, ...optionalFormats])];
      const personalSelectableFormats = [...ALLOWED.formats];
      const manualRequested = input.expertEnabled && input.expert.productFormatMode === "manual";
      const personalFormats = manualRequested
        ? input.expert.selectedProductFormats.filter(value => personalSelectableFormats.includes(value))
        : [];
      const useManual = manualRequested && personalFormats.length > 0;
      const disallowedFormats = ALLOWED.formats.filter(value => !allowedFormats.includes(value));
      const statusByFormat = Object.fromEntries(ALLOWED.formats.map(value => [
        value,
        recommended.has(value) ? "recommended" : optional.has(value) ? "optional" : "blocked"
      ]));
      return {
        defaultFormats: recommendedFormats,
        recommendedFormats,
        optionalFormats,
        disallowedFormats,
        activeFormats: useManual ? personalFormats : recommendedFormats,
        personalFormats: useManual ? personalFormats : [],
        personalSelectableFormats,
        productFormatMode: useManual ? "manual" : "auto",
        statusByFormat
      };
    }

    function buildGuidance(input, carbTarget, timeline) {
      const short = input.durationMinutes < 45;
      let beforeText;
      let beforeExtra = "";
      if (short) beforeText = "Keine spezielle Sportverpflegung nötig. Starte normal versorgt und trinke nach Durst.";
      else if (input.durationMinutes < 90) beforeText = "Eine normale, vertraute Mahlzeit vorher reicht meist. Starte weder hungrig noch sehr voll.";
      else beforeText = "Iss 1–3 Stunden vorher eine vertraute, kohlenhydratbetonte und leicht verdauliche Mahlzeit.";
      if (input.context === "race") beforeExtra = "Am Wettkampftag nichts Neues ausprobieren.";
      else if (input.intensity === "hart") beforeExtra = "Vor harten Einheiten nur Erprobtes verwenden.";

      const noFuelReason = carbTarget.planRateGph > 0 ? null : short ? "UNDER_45" : "OPTIONAL_FOR_CONTEXT";
      const ultraPattern = input.durationMinutes > 360;
      const duringText = noFuelReason === "UNDER_45"
        ? "Während dieser kurzen Einheit ist normalerweise kein Fuelling nötig."
        : noFuelReason === "OPTIONAL_FOR_CONTEXT"
          ? "Für diese lockere Übergangseinheit ist Fuelling während der Belastung optional."
          : ultraPattern
            ? `Nutze das gezeigte 3-Stunden-Muster mit ${timeline.plannedTotalCarbs} g als wiederholbare Orientierung und passe es unterwegs an Verträglichkeit und reale Bedingungen an.`
          : timeline.intakeCount === 1
            ? `Plane eine Einnahme mit ${timeline.plannedTotalCarbs} g nach ungefähr ${timeline.intakes[0].minuteDisplay} Minuten.`
            : `Starte früh und verteile insgesamt ${timeline.plannedTotalCarbs} g auf ${timeline.intakeCount} Einnahmen – ungefähr alle ${timeline.displayIntervalMinutes} Minuten.`;
      let duringExtra = "";
      if (carbTarget.limitedByTolerance) {
        duringExtra = input.toleranceBand === "unknown" && carbTarget.toleranceSource === "tolerance_band"
          ? "Wir verwenden einen vorsichtigen Startwert. Teste höhere Mengen schrittweise im Training."
          : "Der Plan liegt bewusst unter deinem Belastungswert. Steigere die Menge nur schrittweise im Training.";
      } else if (input.durationMinutes >= 360) duringExtra = "Unterschiedliche Geschmäcker und Konsistenzen können bei sehr langen Belastungen helfen.";

      const recoveryPriority = input.durationMinutes >= 90 || (input.durationMinutes >= 60 && (input.context === "race" || input.intensity === "hart"));
      const afterText = recoveryPriority
        ? "Plane danach eine Mahlzeit oder einen Snack mit Kohlenhydraten und etwa 20–40 g Protein."
        : "Danach reicht normalerweise deine nächste ausgewogene Mahlzeit.";
      const afterExtra = recoveryPriority ? "Wenn am selben Tag nochmals eine harte Einheit folgt, beginne mit der Verpflegung möglichst bald." : "";
      const showCaffeineInfo = input.durationMinutes >= 60 && (input.context === "race" || input.intensity === "hart");
      return { beforeText, beforeExtra, duringText, duringExtra: duringExtra.trim(), afterText, afterExtra, showCaffeineInfo, noFuelReason };
    }

    function buildPrimaryWarning(input, carbTarget) {
      if (carbTarget.planRateGph === 90) return { key: "HIGH_CARB_90", title: "Hohe Kohlenhydratmenge", text: "90 g/h nur verwenden, wenn du diese Menge wiederholt im Training vertragen hast. Steigere nicht erstmals im Wettkampf auf diesen Wert." };
      if (carbTarget.expertRateAboveTargetRange) return { key: "EXPERT_ABOVE_TARGET", title: "Expertenwert eingeordnet", text: "Deine getestete Obergrenze liegt über dem Bereich dieser Einheit. Der Plan bleibt deshalb beim niedrigeren Belastungswert." };
      if (carbTarget.limitedByTolerance && input.toleranceBand === "unknown" && carbTarget.toleranceSource === "tolerance_band") {
        return { key: "UNTESTED_START", title: "Vorsichtiger Startwert", text: "Du hast noch keine feste Menge bestätigt. Teste höhere Werte schrittweise in vergleichbaren Trainingseinheiten." };
      }
      if (carbTarget.limitedByTolerance) return { key: "LIMITED_BY_TOLERANCE", title: "Bewusst sanfter geplant", text: "Der Belastungswert liegt höher als deine bestätigte Menge. Baue höhere Mengen schrittweise im Training auf." };
      return null;
    }

    function computePlan(rawState) {
      const validation = validateAndNormalizeInput(rawState);
      if (!validation.ok) return { status: "error", errors: validation.errors };
      const input = validation.input;
      const carbTarget = computeCarbTarget(input);
      const ultraPattern = input.durationMinutes > 360;
      const timeline = computeTimeline(carbTarget.planRateGph, ultraPattern ? 180 : input.durationMinutes);
      timeline.mode = ultraPattern ? "ultra_pattern" : "full_duration";
      timeline.eventDurationMinutes = input.durationMinutes;
      timeline.estimatedFullTotalCarbs = roundTo5(carbTarget.planRateGph * input.durationMinutes / 60);
      const hydration = computeHydration(input);
      const formats = computeFormatPlan(input, carbTarget);
      const guidance = buildGuidance(input, carbTarget, timeline);
      const primaryWarning = buildPrimaryWarning(input, carbTarget);
      return { status: carbTarget.planRateGph > 0 ? "fuel" : "no_fuel", noFuelReason: guidance.noFuelReason, input, carbTarget, timeline, hydration, formats, guidance, primaryWarning };
    }

    function automaticTestPackageOrder(plan) {
      const { sport, context, intensity, durationMinutes } = plan.input;
      // Erste Karte: szenario-spezifische Box. Zweite Karte: passende Misch-Box,
      // deren Breite mit der Empfehlung skaliert (Einstieg drink → Endurance long → Complete starter).
      // Ausnahme harte Laufeinheit: keine Chews, daher Drink&Gel statt Complete.
      if (sport === "tri") return ["high_carb", "starter", "race", "long", "gel", "drink", "caffeine_free"];
      if (sport === "laufen" && intensity === "hart") return ["high_carb", "drink", "gel", "caffeine_free"];
      if (sport === "laufen" && context === "race") return ["race", "starter", "high_carb", "gel", "drink", "caffeine_free"];
      if (sport === "laufen") return ["gel", "drink", "starter", "caffeine_free", "high_carb"];
      if (sport === "rad" && durationMinutes >= 180) return ["long", "high_carb", "starter", "gel", "drink", "caffeine_free"];
      if (sport === "trail" && durationMinutes >= 180) return ["long", "starter", "chew", "gel", "drink", "caffeine_free", "high_carb"];
      return ["starter", "gel", "drink", "caffeine_free", "high_carb"];
    }

    function manualTestPackageOrder(plan) {
      const selected = new Set(plan.formats.personalFormats || []);
      if (selected.size === 1 && selected.has("drink")) return ["drink"];
      return TEST_PACKAGE_ROLE_ORDER
        .filter(role => {
          const config = TEST_PACKAGE_ROLES[role];
          if (!config.formats.some(format => selected.has(format))) return false;
          if (plan.input.sport === "laufen" && plan.input.intensity === "hart" && !selected.has("chews") && config.formats.includes("chews")) return false;
          return true;
        })
        .map((role, stableIndex) => {
          const config = TEST_PACKAGE_ROLES[role];
          const overlap = config.formats.filter(format => selected.has(format)).length;
          const extras = config.formats.filter(format => !selected.has(format)).length;
          let roleBoost = 0;
          if (selected.has("chews") && role === "chew") roleBoost += 80;
          if (selected.has("riegel") && role === "long") roleBoost += 60;
          if (selected.has("riegel") && role === "starter") roleBoost += 50;
          if (selected.has("drink") && role === "drink") roleBoost += 50;
          if (selected.has("gel") && role === "gel") roleBoost += 40;
          return { role, score: overlap * 10 - extras + roleBoost, stableIndex };
        })
        .sort((left, right) => right.score - left.score || left.stableIndex - right.stableIndex)
        .map(item => item.role);
    }

    function selectTestPackageRoles(plan, catalog) {
      if (!plan || plan.status !== "fuel" || !catalog || typeof catalog !== "object") return [];
      const manual = plan.formats.productFormatMode === "manual" && plan.formats.personalFormats.length > 0;
      const orderedRoles = manual ? manualTestPackageOrder(plan) : automaticTestPackageOrder(plan);
      const selectedRoles = [];
      const seenProductIds = new Set();
      for (const role of orderedRoles) {
        const item = catalog[role];
        if (!TEST_PACKAGE_ROLES[role] || !item || item.available !== true || typeof item.productId !== "string" || !item.productId) continue;
        if (seenProductIds.has(item.productId)) continue;
        seenProductIds.add(item.productId);
        selectedRoles.push(role);
        if (selectedRoles.length === 2) break;
      }
      return selectedRoles;
    }

    globalThis.FuelboxCarbPlannerCore = Object.freeze({
      DEFAULT_STATE,
      SPORT_CAP_MINUTES,
      TOLERANCE_CAPS,
      validateAndNormalizeInput,
      computeTargetRange,
      blendRate,
      computeTransitionedTableRate,
      getEffectiveToleranceCap,
      computeCarbTarget,
      distributeCarbs,
      computeTimeline,
      computeHydration,
      computeFormatPlan,
      buildGuidance,
      buildPrimaryWarning,
      computePlan,
      TEST_PACKAGE_ROLES,
      automaticTestPackageOrder,
      manualTestPackageOrder,
      selectTestPackageRoles
    });



  class FuelboxCarbPlanner extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      const component = this;
      const sectionId = this.dataset.sectionId;
      const abortController = new AbortController();
      const { signal } = abortController;
      this._abortController = abortController;
      const on = (target, type, listener) => target.addEventListener(type, listener, { signal });
      const durationBand = minutes => minutes < 45 ? "under_45" : minutes < 75 ? "45_74" : minutes < 150 ? "75_149" : minutes <= 360 ? "150_360" : "over_360";
      const analyticsAllowed = () => {
        if (window.Shopify?.designMode) return false;
        const privacy = window.Shopify?.customerPrivacy;
        return typeof privacy?.analyticsProcessingAllowed === "function" && privacy.analyticsProcessingAllowed();
      };
      const track = (eventName, payload = {}) => {
        if (!analyticsAllowed()) return;
        const detail = { event: eventName, planner_version: "2", ...payload };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(detail);
        component.dispatchEvent(new CustomEvent(`fb:${eventName}`, { bubbles: true, detail }));
      };


    const state = cloneDefaultState();
    const ui = { step: 1 };
    let lastRenderedPlan = null;
    const $ = id => this.querySelector(`[id="${id}-${sectionId}"]`);
    const all = selector => [...this.querySelectorAll(selector)];
    const formatDuration = minutes => `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, "0")}`;
    const formatTimelineMinute = minute => minute < 60 ? `${minute} min` : `${Math.floor(minute / 60)}:${String(minute % 60).padStart(2, "0")} h`;

    function safeProductUrl(rawUrl) {
      if (typeof rawUrl !== "string" || !rawUrl) return null;
      try {
        const url = new URL(rawUrl, window.location.href);
        const allowedOrigin = window.location.protocol === "file:" ? url.hostname === "fuelbox.ch" : url.origin === window.location.origin;
        const productPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname);
        return allowedOrigin && productPath ? url.href : null;
      } catch (_error) {
        return null;
      }
    }

    function safeProductImageUrl(rawUrl) {
      if (typeof rawUrl !== "string" || !rawUrl) return null;
      try {
        const url = new URL(rawUrl, window.location.href);
        if (!/^https?:$/.test(url.protocol)) return null;
        const allowedHost = url.origin === window.location.origin
          || url.hostname === "fuelbox.ch"
          || url.hostname === "cdn.shopify.com";
        return allowedHost ? url.href : null;
      } catch (_error) {
        return null;
      }
    }

    function parseTestPackageCatalog() {
      const root = $("wizard").closest("[data-planner-url]") || document;
      const script = root.querySelector("[data-package-catalog]");
      if (!script) return Object.freeze({});
      try {
        const raw = JSON.parse(script.textContent || "{}");
        if (raw.schemaVersion !== 1 || !raw.packages || typeof raw.packages !== "object") return Object.freeze({});
        const catalog = {};
        Object.keys(TEST_PACKAGE_ROLES).forEach(role => {
          const item = raw.packages[role];
          if (!item || item.available !== true || typeof item.productId !== "string" || !item.productId) return;
          const url = safeProductUrl(item.url);
          if (!url || typeof item.title !== "string" || !item.title.trim() || typeof item.priceFormatted !== "string" || !item.priceFormatted.trim()) return;
          catalog[role] = Object.freeze({
            productId: item.productId,
            handle: typeof item.handle === "string" ? item.handle : "",
            title: item.title.trim(),
            url,
            imageUrl: safeProductImageUrl(item.imageUrl),
            imageAlt: typeof item.imageAlt === "string" && item.imageAlt.trim() ? item.imageAlt.trim() : item.title.trim(),
            priceFormatted: item.priceFormatted.trim(),
            available: true
          });
        });
        return Object.freeze(catalog);
      } catch (_error) {
        return Object.freeze({});
      }
    }

    const testPackageCatalog = parseTestPackageCatalog();

    function syncChoiceButtons(field) {
      all(`[data-choice-field="${field}"]`).forEach(button => button.setAttribute("aria-pressed", String(button.dataset.value === state[field])));
    }

    function scrollPanelIntoView(panel) {
      const scroll = () => {
        const root = document.documentElement;
        const previousBehavior = root.style.scrollBehavior;
        root.style.scrollBehavior = "auto";
        panel.scrollIntoView({ block: "start", behavior: "auto" });
        root.style.scrollBehavior = previousBehavior;
      };
      if (typeof window.requestAnimationFrame === "function") window.requestAnimationFrame(scroll);
      else scroll();
    }

    function applySportCap() {
      const duration = $("duration");
      const cap = SPORT_CAP_MINUTES[state.sport];
      const notes = {
        laufen: "Von 5 km bis Marathon – Distanzen bis 6 Stunden.",
        rad: "Von der Ausfahrt bis zum langen Gran Fondo – bis 15 Stunden.",
        trail: "Für Trails und Ultras bis 24 Stunden. Sehr lange Pläne unterwegs nach Erfahrung anpassen.",
        tri: "Gib Rad- plus Laufzeit ab dem Radstart ein – ohne Schwimmen. Der MVP teilt Rad und Lauf nicht separat auf."
      };
      duration.max = String(cap);
      if (state.durationMinutes > cap) state.durationMinutes = cap;
      duration.value = String(state.durationMinutes);
      $("durationOutput").textContent = formatDuration(state.durationMinutes);
      $("durationMax").textContent = formatDuration(cap);
      $("durationMid").textContent = formatDuration(Math.round((cap / 2) / 15) * 15);
      $("sportCapNote").textContent = notes[state.sport];
      $("durationLabel").textContent = state.sport === "tri" ? "Verpflegbare Dauer ab Radstart (ohne Schwimmen)" : "Dauer";
      $("durationPresets").hidden = state.sport !== "trail";
      all("[data-duration-preset]").forEach(button => button.setAttribute("aria-pressed", String(Number(button.dataset.durationPreset) === state.durationMinutes)));
    }

    function showStep(stepNumber, focusHeading = true) {
      ui.step = stepNumber;
      all(".fb-cp-step").forEach(step => { step.hidden = Number(step.dataset.step) !== stepNumber; });
      $("progressFill").style.width = `${stepNumber * 25}%`;
      $("progressLabel").textContent = `Schritt ${stepNumber} von 4`;
      $("backButton").disabled = stepNumber === 1;
      $("nextButton").textContent = stepNumber === 4 ? "Plan berechnen →" : "Weiter →";
      $("wizardStatus").textContent = `Schritt ${stepNumber} von 4`;
      if (stepNumber === 4) syncExpertUi();
      if (focusHeading) {
        const heading = $(`step${stepNumber}`).querySelector(".fb-cp-step-heading");
        heading.setAttribute("tabindex", "-1");
        heading.focus({ preventScroll: true });
        scrollPanelIntoView($("wizard"));
      }
    }

    function setText(id, value) { $(id).textContent = value || ""; }

    function renderChips(plan) {
      const input = plan.input;
      const toleranceLabel = input.expertEnabled && input.expert.exactCarbRateEnabled && isValidTestedRate(input.expert.testedCarbRateGph)
        ? `${input.expert.testedCarbRateGph} g/h getestet`
        : LABELS.toleranceBand[input.toleranceBand];
      const chips = [
        LABELS.sport[input.sport], LABELS.context[input.context], `${formatDuration(input.durationMinutes)} h`,
        LABELS.intensity[input.intensity], toleranceLabel, LABELS.conditions[input.conditions]
      ];
      if (input.expertEnabled && input.expert.sweatProfile !== "normal") chips.push(`Trinkfokus: ${input.expert.sweatProfile === "low" ? "eher wenig" : "eher viel"}`);
      if (plan.formats.productFormatMode === "manual") chips.push("Produktwahl: persönlich");
      $("resultChips").innerHTML = chips.map(label => `<span class="fb-cp-chip">${label}</span>`).join("");
    }

    function renderMetrics(plan) {
      const metrics = $("metrics");
      const noFuel = $("noFuel");
      if (plan.status === "no_fuel") {
        metrics.hidden = true;
        noFuel.hidden = false;
        noFuel.innerHTML = plan.noFuelReason === "UNDER_45"
          ? "<strong>Kein Fuelling nötig</strong><span>Trinken nach Durst reicht normalerweise. Bei Hitze gilt der separate Trinkhinweis unten.</span>"
          : "<strong>Fuelling optional</strong><span>Für diese lockere Übergangseinheit ist keine feste Kohlenhydratmenge während der Belastung eingeplant. Der Trinkhinweis bleibt davon unabhängig.</span>";
        return;
      }
      metrics.hidden = false;
      noFuel.hidden = true;
      const totalLabel = plan.timeline.mode === "ultra_pattern" ? "3-h-Muster" : "Gesamtmenge";
      const totalNote = plan.timeline.mode === "ultra_pattern" ? "wiederholen und unterwegs anpassen" : `über ${formatDuration(plan.input.durationMinutes)} h`;
      metrics.innerHTML = `
        <article class="fb-cp-card fb-cp-metric fb-cp-metric-primary"><div class="fb-cp-metric-label">Dein Planwert</div><div class="fb-cp-metric-value">${plan.carbTarget.planRateGph} g/h</div><div class="fb-cp-metric-note">aktuell geplante Menge</div></article>
        <article class="fb-cp-card fb-cp-metric"><div class="fb-cp-metric-label">${totalLabel}</div><div class="fb-cp-metric-value">${plan.timeline.plannedTotalCarbs} g</div><div class="fb-cp-metric-note">${totalNote}</div></article>
        <article class="fb-cp-card fb-cp-metric"><div class="fb-cp-metric-label">Rhythmus</div><div class="fb-cp-metric-value">${plan.timeline.intakeCount === 1 ? "1×" : `~${plan.timeline.displayIntervalMinutes} min`}</div><div class="fb-cp-metric-note">${plan.timeline.intakeCount === 1 ? `nach etwa ${plan.timeline.intakes[0].minuteDisplay} min` : `${plan.timeline.intakeCount} Einnahmen`}</div></article>`;
    }

    function renderWarning(plan) {
      const warning = $("primaryWarning");
      if (!plan.primaryWarning) { warning.hidden = true; warning.innerHTML = ""; return; }
      warning.hidden = false;
      warning.classList.toggle("fb-cp-warning", plan.primaryWarning.key === "HIGH_CARB_90");
      warning.innerHTML = `<strong>${plan.primaryWarning.title}</strong><span>${plan.primaryWarning.text}</span>`;
    }

    function renderTimeline(plan) {
      const section = $("timelineSection");
      if (plan.status === "no_fuel") { section.hidden = true; return; }
      section.hidden = false;
      setText("timelineHeading", plan.timeline.mode === "ultra_pattern" ? "Fuelling-Muster für die ersten 3 Stunden" : "Fuelling-Timeline");
      setText("timelineSummary", plan.timeline.intakeCount === 1
        ? `1 Einnahme · nach etwa ${plan.timeline.intakes[0].minuteDisplay} min`
        : `${plan.timeline.intakeCount} Einnahmen · etwa alle ${plan.timeline.displayIntervalMinutes} min`);
      const intakes = plan.timeline.intakes;
      const visualIntakes = intakes.length <= 12 ? intakes : intakes.filter((_, index) => index % Math.ceil(intakes.length / 10) === 0).slice(0, 10);
      $("timelineVisual").innerHTML = `<div class="fb-cp-timeline-track">${visualIntakes.map(item => {
        const left = Math.max(1.5, Math.min(98.5, item.minuteRaw / plan.timeline.plannedDurationMinutes * 100));
        return `<div class="fb-cp-timeline-marker" style="left:${left}%"><span class="fb-cp-timeline-time">${formatTimelineMinute(item.minuteDisplay)}</span><span class="fb-cp-timeline-dot">${item.carbsG}</span></div>`;
      }).join("")}</div><div class="fb-cp-timeline-axis"><span>Start</span><span>${formatDuration(plan.timeline.plannedDurationMinutes)} h</span></div>`;
      $("timelineList").innerHTML = intakes.map(item => `<li><span class="fb-cp-mono">${formatTimelineMinute(item.minuteDisplay)}</span> – ${item.carbsG} g</li>`).join("");
      $("timelineDetails").open = false;
    }

    function renderFormats(plan) {
      const categoryLinks = $("categoryLinks");
      const categoryNote = $("productCategoryNote");
      const drinkPackageNote = $("drinkPackageNote");
      categoryLinks.replaceChildren();
      categoryNote.hidden = plan.status === "no_fuel";
      drinkPackageNote.hidden = true;
      if (plan.status === "no_fuel") {
        setText("productText", "Für diese kurze Einheit musst du keine Sportverpflegung einplanen.");
        $("formatList").innerHTML = "";
        $("personalProductText").hidden = true;
        $("personalFormatList").hidden = true;
        $("personalFormatList").innerHTML = "";
        categoryLinks.hidden = true;
        return;
      }
      const sportHint = plan.input.sport === "laufen" && plan.input.intensity === "hart"
        ? "Bei harten Laufeinheiten empfiehlt FuelBox keine Chews. Im Expertenmodus können sie trotzdem persönlich gewählt werden."
        : ({
        laufen: "Beim Laufen sind einfach einzunehmende Formen meist praktischer.",
        rad: "Lege die Einnahmen auf dem Rad griffbereit; kaubare Formen sind gut umsetzbar.",
        trail: "Drink-Mix gehört zur Empfehlung; bei langen Trails helfen zusätzlich unterschiedliche, vorher getestete Geschmäcker und Konsistenzen.",
        tri: "Nutze den Radabschnitt für planbare Aufnahme und beim Laufen einfachere Formen."
      }[plan.input.sport]);
      setText("productText", `FuelBox empfiehlt für diesen Plan: ${plan.formats.recommendedFormats.map(value => LABELS.formats[value]).join(", ")}. ${sportHint}`);
      $("formatList").innerHTML = plan.formats.recommendedFormats.map(value => `<span class="fb-cp-format-chip">${LABELS.formats[value]}</span>`).join("");
      const personal = plan.formats.productFormatMode === "manual" ? plan.formats.personalFormats : [];
      $("personalProductText").hidden = personal.length === 0;
      $("personalFormatList").hidden = personal.length === 0;
      setText("personalProductText", personal.length ? "Deine persönliche Auswahl:" : "");
      $("personalFormatList").innerHTML = personal.map(value => `<span class="fb-cp-format-chip">${LABELS.formats[value]}</span>`).join("");
      const categoryRoot = $("result").closest("[data-collection-gel-url]");
      const categoryFormats = personal.length ? personal : plan.formats.recommendedFormats;
      categoryFormats.forEach(value => {
        const config = CATEGORY_LINKS[value];
        if (!config) return;
        const link = document.createElement("a");
        link.className = "fb-cp-category-link";
        link.href = categoryRoot?.dataset[config.datasetKey] || config.fallbackUrl;
        link.dataset.productCategory = value;
        link.textContent = `${config.label} →`;
        categoryLinks.append(link);
      });
      categoryLinks.hidden = categoryFormats.length === 0;
      drinkPackageNote.hidden = !(personal.length === 1 && personal[0] === "drink" && !testPackageCatalog.drink);
    }

    function renderTestPackages(plan) {
      const section = $("testPackagesSection");
      const grid = $("testPackagesGrid");
      grid.replaceChildren();
      const roles = selectTestPackageRoles(plan, testPackageCatalog);
      if (roles.length === 0) {
        section.hidden = true;
        return;
      }
      roles.forEach((role, index) => {
        const item = testPackageCatalog[role];
        const config = TEST_PACKAGE_ROLES[role];
        const card = document.createElement("article");
        card.className = "fb-cp-test-package-card";

        const media = document.createElement("div");
        media.className = "fb-cp-test-package-media";
        if (item.imageUrl) {
          const image = document.createElement("img");
          image.src = item.imageUrl;
          image.alt = item.imageAlt === item.title ? "" : item.imageAlt;
          image.width = 720;
          image.height = 450;
          image.loading = "lazy";
          image.decoding = "async";
          media.append(image);
        } else {
          const placeholder = document.createElement("span");
          placeholder.className = "fb-cp-test-package-placeholder";
          placeholder.setAttribute("aria-hidden", "true");
          placeholder.textContent = "FB";
          media.append(placeholder);
        }

        const body = document.createElement("div");
        body.className = "fb-cp-test-package-body";
        const heading = document.createElement("h3");
        heading.textContent = item.title;
        const reason = document.createElement("p");
        reason.className = "fb-cp-test-package-reason";
        reason.textContent = config.reason;
        const footer = document.createElement("div");
        footer.className = "fb-cp-test-package-footer";
        const price = document.createElement("span");
        price.className = "fb-cp-test-package-price";
        price.textContent = item.priceFormatted;
        const link = document.createElement("a");
        link.className = "fb-cp-test-package-link";
        link.href = item.url;
        link.textContent = "Testpaket ansehen";
        link.setAttribute("aria-label", `Testpaket ${item.title} ansehen`);
        link.dataset.testPackageRole = role;
        link.dataset.testPackageHandle = item.handle;
        link.dataset.testPackagePosition = String(index + 1);
        footer.append(price, link);
        body.append(heading, reason, footer);
        card.append(media, body);
        grid.append(card);
      });
      section.hidden = false;
    }

    function renderExpertFormatOptions(plan) {
      const active = new Set(plan.formats.activeFormats);
      const manual = state.expert.productFormatMode === "manual";
      const statusLabels = { recommended: "Empfohlen", optional: "Optional", blocked: "Nicht empfohlen", personal: "Persönlich wählbar" };
      $("formatOptions").innerHTML = ALLOWED.formats.map(value => {
        const status = manual ? "personal" : plan.formats.statusByFormat[value];
        const disabled = !manual;
        return `<button class="fb-cp-format-option" type="button" data-format="${value}" data-status="${status}" aria-pressed="${active.has(value)}" ${disabled ? "disabled" : ""}><span>${LABELS.formats[value]}</span><small>${statusLabels[status]}</small></button>`;
      }).join("");
    }

    function reconcilePersonalFormats() {
      if (state.expert.productFormatMode !== "manual") return "";
      const automaticState = {
        ...state,
        expert: { ...state.expert, productFormatMode: "auto", selectedProductFormats: [] }
      };
      const automaticPlan = computePlan(automaticState);
      if (automaticPlan.status === "error" || automaticPlan.status === "no_fuel") {
        state.expert.productFormatMode = "auto";
        return automaticPlan.status === "no_fuel" ? "Bei diesem Plan ist keine Produktform nötig; die automatische Auswahl ist wieder aktiv." : "Die persönliche Auswahl wurde auf automatisch zurückgesetzt.";
      }
      const previous = [...state.expert.selectedProductFormats];
      const selectable = new Set(automaticPlan.formats.personalSelectableFormats);
      state.expert.selectedProductFormats = previous.filter(value => selectable.has(value));
      const removed = previous.filter(value => !selectable.has(value));
      if (state.expert.selectedProductFormats.length === 0) {
        state.expert.productFormatMode = "auto";
        return removed.length ? `Nicht verfügbare Auswahl entfernt: ${removed.map(value => LABELS.formats[value]).join(", ")}. Die automatische Empfehlung ist wieder aktiv.` : "Die automatische Empfehlung ist wieder aktiv.";
      }
      return removed.length ? `Nicht verfügbare Auswahl entfernt: ${removed.map(value => LABELS.formats[value]).join(", ")}.` : "";
    }

    function syncExpertUi(plan = computePlan(state), message = "") {
      $("expertToggle").setAttribute("aria-checked", String(state.expertEnabled));
      $("expertToggle").setAttribute("aria-expanded", String(state.expertEnabled));
      $("expertBody").hidden = !state.expertEnabled;
      const fallbackRate = TOLERANCE_CAPS[state.toleranceBand];
      const displayedRate = state.expert.testedCarbRateGph || fallbackRate;
      $("expertRateOutput").textContent = String(displayedRate);
      $("expertRate").value = String(displayedRate);
      $("expertRateConfirmed").checked = state.expert.exactCarbRateEnabled;
      $("expertRatePanel").hidden = !state.expert.exactCarbRateEnabled;
      setText("expertRateContext", state.expert.exactCarbRateEnabled
        ? `Für diesen Plan gilt der gewählte Wert anstelle von „${LABELS.toleranceBand[state.toleranceBand]}“ als persönliche Obergrenze. Er erhöht den automatisch ermittelten Belastungswert nicht.`
        : "");
      $("expertHighRateNote").hidden = !(state.expert.exactCarbRateEnabled && displayedRate > PUBLIC_MAX_G_PER_HOUR);
      all("[data-sweat]").forEach(button => button.setAttribute("aria-pressed", String(button.dataset.sweat === state.expert.sweatProfile)));
      all("[data-format-mode]").forEach(button => button.setAttribute("aria-pressed", String(button.dataset.formatMode === state.expert.productFormatMode)));
      $("formatModeManual").disabled = plan.status === "no_fuel";
      if (plan.status !== "error") renderExpertFormatOptions(plan);
      const defaultStatus = state.expert.productFormatMode === "manual"
        ? "Deine Auswahl wird separat von der FuelBox-Empfehlung angezeigt."
        : "Die FuelBox-Empfehlung wird automatisch aus deinen Angaben aktualisiert.";
      setText("formatStatus", message || defaultStatus);
    }

    function renderGuidance(plan) {
      setText("beforeText", plan.guidance.beforeText);
      setText("beforeExtra", plan.guidance.beforeExtra);
      setText("duringText", plan.guidance.duringText);
      setText("duringExtra", plan.guidance.duringExtra);
      setText("afterText", plan.guidance.afterText);
      setText("afterExtra", plan.guidance.afterExtra);
      $("caffeineInfo").hidden = !plan.guidance.showCaffeineInfo;
    }

    function renderHydration(plan) {
      const hydration = plan.hydration;
      if (hydration.mode === "thirst") {
        $("hydrationContent").innerHTML = "<div><div class=\"hydration-value\">Nach Durst</div><p>Für diese kurze Einheit ist normalerweise kein Liter-pro-Stunde-Ziel nötig.</p></div>";
        setText("hydrationSafety", plan.input.conditions === "heiss" ? "Halte trotzdem Flüssigkeit bereit und starte gut hydriert." : "");
        return;
      }
      const totalText = hydration.showTotal
        ? `<div><div class="fb-cp-hydration-value">${hydration.fluidTotalMinL}–${hydration.fluidTotalMaxL} L</div><p>ungefähr über die gesamte Dauer</p></div>`
        : `<div><div class="fb-cp-hydration-value">Nachfüllen planen</div><p>Bei mehr als vier Stunden nicht die gesamte Menge als mitzuführende Liter verstehen.</p></div>`;
      const sodiumText = hydration.sodiumGuidance === "400_700_MG_PER_L"
        ? " Ein Getränk mit ungefähr 400–700 mg Natrium pro Liter kann praktisch sein."
        : "";
      $("hydrationContent").innerHTML = `<div><div class="fb-cp-hydration-value">${hydration.fluidRateMinLph}–${hydration.fluidRateMaxLph} L/h</div><p>als Startbereich.${sodiumText}</p></div>${totalText}`;
      setText("hydrationSafety", "Der Bereich ist eine Startorientierung, kein Trinkziel. Trinke nach Durst, Erfahrung und realen Bedingungen. Natrium macht übermässiges Trinken nicht sicher.");
    }

    function renderLead(plan) {
      if (plan.status === "no_fuel") {
        setText("resultLead", plan.noFuelReason === "UNDER_45"
          ? "Für diese kurze Einheit ist normalerweise kein Fuelling während der Belastung nötig."
          : "Für diese lockere Übergangseinheit ist Fuelling während der Belastung optional.");
        return;
      }
      let explanation = plan.timeline.mode === "ultra_pattern"
        ? `Für ${formatDuration(plan.input.durationMinutes)} h ${LABELS.sport[plan.input.sport]} planen wir mit ${plan.carbTarget.planRateGph} g Kohlenhydraten pro Stunde. Statt einer scheinbar exakten Gesamtmenge zeigt der Planner ein 3-Stunden-Muster.`
        : `Für ${formatDuration(plan.input.durationMinutes)} h ${LABELS.sport[plan.input.sport]} planen wir mit ${plan.carbTarget.planRateGph} g Kohlenhydraten pro Stunde – insgesamt rund ${plan.timeline.plannedTotalCarbs} g.`;
      if (plan.carbTarget.expertRateStatus === "limits_plan") explanation += ` Verwendet wird deine mehrfach getestete Obergrenze von ${plan.input.expert.testedCarbRateGph} g/h.`;
      else if (plan.carbTarget.toleranceSource === "expert_tested") explanation += ` Deine getestete Obergrenze von ${plan.input.expert.testedCarbRateGph} g/h wurde berücksichtigt; für diese Einheit planen wir niedriger.`;
      setText("resultLead", explanation);
    }

    function renderPlanContext(plan) {
      if (plan.status === "no_fuel" && plan.noFuelReason === "UNDER_45") {
        setText("planContext", "Allgemeiner Zielbereich: 0 g/h.");
        return;
      }
      const range = `${plan.carbTarget.targetRangeMinGph}–${plan.carbTarget.targetRangeMaxGph} g/h`;
      if (plan.carbTarget.belowTargetDueToTransition) {
        setText("planContext", `Allgemeiner Bereich der neuen Dauerstufe: ${range}. Weil du gerade in der Übergangszone liegst, steigt der konkrete Planwert schrittweise an.`);
      } else if (plan.carbTarget.limitedByTolerance && plan.input.toleranceBand === "unknown" && plan.carbTarget.toleranceSource === "tolerance_band") {
        setText("planContext", `Allgemeiner Zielbereich: ${range}. Weil du noch keine feste Menge bestätigt hast, verwendet der Planner einen vorsichtigen Startwert.`);
      } else if (plan.carbTarget.limitedByTolerance) {
        setText("planContext", `Allgemeiner Zielbereich: ${range}. Der Plan liegt wegen deiner bestätigten Verträglichkeit bewusst darunter.`);
      } else {
        setText("planContext", `Allgemeiner Zielbereich für diese Belastung: ${range}.`);
      }
    }

    function renderResult() {
      const plan = computePlan(state);
      lastRenderedPlan = plan;
      component._lastPlan = plan;
      if (plan.status === "error") {
        $("wizardStatus").textContent = "Der Plan konnte nicht berechnet werden. Bitte prüfe die Eingaben.";
        showStep(2);
        return;
      }
      renderLead(plan);
      renderChips(plan);
      renderPlanContext(plan);
      renderMetrics(plan);
      renderWarning(plan);
      renderTimeline(plan);
      renderFormats(plan);
      renderTestPackages(plan);
      renderExpertFormatOptions(plan);
      renderGuidance(plan);
      renderHydration(plan);
      syncExpertUi(plan);
      $("resultStatus").textContent = `Plan aktualisiert: ${plan.carbTarget.planRateGph} Gramm Kohlenhydrate pro Stunde.`;
    }

    function showResult() {
      $("wizard").hidden = true;
      $("result").hidden = false;
      renderResult();
      $("resultHeading").focus({ preventScroll: true });
      scrollPanelIntoView($("result"));
    }

    const exportRoot = $("wizard").closest("[data-pdf-vendor-url]") || document.documentElement;
    let exportBusy = false;

    function setExportStatus(message, stateName = "") {
      $("pdfStatus").textContent = message;
      $("pdfStatus").dataset.state = stateName;
    }

    function setExportBusy(busy) {
      exportBusy = busy;
      $("pdfDownloadButton").disabled = busy;
      $("pdfShareButton").disabled = busy;
      $("pdfDownloadButton").textContent = busy ? "PDF wird erstellt …" : "Plan als PDF herunterladen";
    }

    function ensurePdfRuntime() {
      if (globalThis.jspdf?.jsPDF && globalThis.FuelboxCarbPlannerPdf) return Promise.resolve();
      if (!globalThis.FuelboxCarbPlannerPdf) return Promise.reject(new Error("PDF_HELPER_NOT_LOADED"));
      if (globalThis.__fuelboxJspdfPromise) return globalThis.__fuelboxJspdfPromise;
      const source = exportRoot.dataset.pdfVendorUrl;
      if (!source) return Promise.reject(new Error("PDF_VENDOR_URL_MISSING"));
      globalThis.__fuelboxJspdfPromise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = source;
        script.async = true;
        script.dataset.fuelboxJspdf = "4.2.1";
        script.onload = () => globalThis.jspdf?.jsPDF ? resolve() : reject(new Error("PDF_VENDOR_INVALID"));
        script.onerror = () => reject(new Error("PDF_VENDOR_LOAD_FAILED"));
        document.head.append(script);
      }).catch(error => {
        delete globalThis.__fuelboxJspdfPromise;
        throw error;
      });
      return globalThis.__fuelboxJspdfPromise;
    }

    function createPdfResult() {
      if (!lastRenderedPlan || lastRenderedPlan.status === "error") throw new Error("PDF_PLAN_MISSING");
      return globalThis.FuelboxCarbPlannerPdf.generatePdf(lastRenderedPlan, {
        plannerUrl: exportRoot.dataset.plannerUrl || "https://fuelbox.ch/pages/carb-planner"
      });
    }

    function downloadPdfBlob(pdf) {
      const url = URL.createObjectURL(pdf.blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = pdf.fileName;
      link.rel = "noopener";
      document.body.append(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 30000);
    }

    function announceExportSuccess(action, pdf) {
      $("pdfDownloadButton").dispatchEvent(new CustomEvent("fb:carb-planner-export-success", {
        bubbles: true,
        detail: { action, pageCount: pdf.pageCount }
      }));
    }

    async function downloadPdf() {
      if (exportBusy) return;
      setExportBusy(true);
      setExportStatus("PDF wird vorbereitet …");
      try {
        await ensurePdfRuntime();
        const pdf = createPdfResult();
        downloadPdfBlob(pdf);
        setExportStatus("PDF wurde erstellt.", "success");
        announceExportSuccess("download", pdf);
      } catch (error) {
        console.error("FuelBox PDF export failed", error);
        setExportStatus("Das PDF konnte nicht erstellt werden. Versuche es bitte erneut.", "error");
      } finally {
        setExportBusy(false);
      }
    }

    async function sharePdf() {
      if (exportBusy) return;
      setExportBusy(true);
      setExportStatus("PDF wird zum Teilen vorbereitet …");
      try {
        await ensurePdfRuntime();
        const pdf = createPdfResult();
        const file = new File([pdf.blob], pdf.fileName, { type: "application/pdf" });
        if (!navigator.canShare?.({ files: [file] })) {
          downloadPdfBlob(pdf);
          setExportStatus("Teilen wird hier nicht unterstützt. Das PDF wurde stattdessen heruntergeladen.", "success");
          announceExportSuccess("share_fallback_download", pdf);
          return;
        }
        await navigator.share({
          title: "Mein FuelBox Carb-Plan",
          text: "Mein persönlicher Carb-Plan von FuelBox.",
          files: [file]
        });
        setExportStatus("Plan wurde zum Teilen geöffnet.", "success");
        announceExportSuccess("share", pdf);
      } catch (error) {
        if (error?.name === "AbortError") {
          setExportStatus("Teilen wurde abgebrochen.");
        } else {
          console.error("FuelBox PDF share failed", error);
          try {
            const pdf = createPdfResult();
            downloadPdfBlob(pdf);
            setExportStatus("Teilen war nicht möglich. Das PDF wurde stattdessen heruntergeladen.", "success");
            announceExportSuccess("share_error_fallback_download", pdf);
          } catch (fallbackError) {
            console.error("FuelBox PDF share fallback failed", fallbackError);
            setExportStatus("Teilen und Download sind gerade nicht möglich. Versuche es bitte später erneut.", "error");
          }
        }
      } finally {
        setExportBusy(false);
      }
    }

    $("pdfShareButton").hidden = !(typeof navigator.share === "function" && typeof navigator.canShare === "function" && typeof File === "function");
    on($("pdfDownloadButton"), "click", downloadPdf);
    on($("pdfShareButton"), "click", sharePdf);
    function refreshExpertAfterInputChange() {
      const message = reconcilePersonalFormats();
      syncExpertUi(computePlan(state), message);
    }

    all("[data-choice-field]").forEach(button => on(button, "click", () => {
      const field = button.dataset.choiceField;
      state[field] = button.dataset.value;
      syncChoiceButtons(field);
      if (field === "sport") applySportCap();
      if (state.expertEnabled) refreshExpertAfterInputChange();
    }));

    function setDuration(value) {
      state.durationMinutes = Number(value);
      $("duration").value = String(state.durationMinutes);
      $("durationOutput").textContent = formatDuration(state.durationMinutes);
      all("[data-duration-preset]").forEach(button => button.setAttribute("aria-pressed", String(Number(button.dataset.durationPreset) === state.durationMinutes)));
      if (state.expertEnabled) refreshExpertAfterInputChange();
    }

    on($("duration"), "input", event => setDuration(event.target.value));
    all("[data-duration-preset]").forEach(button => on(button, "click", () => {
      setDuration(button.dataset.durationPreset);
    }));
    on($("nextButton"), "click", () => ui.step < 4 ? showStep(ui.step + 1) : showResult());
    on($("backButton"), "click", () => { if (ui.step > 1) showStep(ui.step - 1); });
    on($("editButton"), "click", () => { $("result").hidden = true; $("wizard").hidden = false; showStep(4); });

    on($("expertToggle"), "click", () => {
      state.expertEnabled = !state.expertEnabled;
      const message = state.expertEnabled ? reconcilePersonalFormats() : "";
      syncExpertUi(computePlan(state), message);
    });
    on($("expertRate"), "input", event => {
      state.expert.testedCarbRateGph = Number(event.target.value);
      $("expertRateOutput").textContent = event.target.value;
      if (state.expert.exactCarbRateEnabled) syncExpertUi(computePlan(state));
    });
    on($("expertRateConfirmed"), "change", event => {
      state.expert.exactCarbRateEnabled = event.target.checked;
      if (event.target.checked && !state.expert.testedCarbRateGph) state.expert.testedCarbRateGph = Number($("expertRate").value);
      syncExpertUi(computePlan(state));
    });
    all("[data-sweat]").forEach(button => on(button, "click", () => {
      state.expert.sweatProfile = button.dataset.sweat;
      syncExpertUi(computePlan(state));
    }));
    all("[data-format-mode]").forEach(button => on(button, "click", () => {
      const mode = button.dataset.formatMode;
      if (mode === "manual" && state.expert.selectedProductFormats.length === 0) {
        const automaticPlan = computePlan({
          ...state,
          expert: { ...state.expert, productFormatMode: "auto", selectedProductFormats: [] }
        });
        if (automaticPlan.status === "no_fuel") {
          syncExpertUi(automaticPlan, "Für diesen Plan ist keine persönliche Produktwahl nötig.");
          return;
        }
        state.expert.selectedProductFormats = automaticPlan.status === "fuel" ? [...automaticPlan.formats.recommendedFormats] : [];
      }
      state.expert.productFormatMode = mode;
      syncExpertUi(computePlan(state), mode === "manual" ? "Du kannst alle Produktformen persönlich kombinieren. Die FuelBox-Empfehlung bleibt davon getrennt." : "Die FuelBox-Empfehlung ist wieder automatisch aktiv.");
    }));
    on($("formatOptions"), "click", event => {
      const button = event.target.closest("[data-format]");
      if (!button || button.disabled || state.expert.productFormatMode !== "manual") return;
      const current = [...state.expert.selectedProductFormats];
      const value = button.dataset.format;
      const next = current.includes(value) ? current.filter(item => item !== value) : [...current, value];
      if (next.length === 0) {
        setText("formatStatus", "Mindestens eine geeignete Produktform muss aktiv bleiben.");
        return;
      }
      state.expert.selectedProductFormats = next.filter(item => ALLOWED.formats.includes(item));
      syncExpertUi(computePlan(state));
    });

      let started = false;
      on($("nextButton"), "click", () => {
        if (!started) {
          started = true;
          track("carb_planner_started");
        }
        const completedStep = $("result").hidden ? Math.max(1, ui.step - 1) : 4;
        track("carb_planner_step_completed", { step: completedStep });
      });
      on($("expertToggle"), "click", () => {
        if (state.expertEnabled) track("carb_planner_expert_enabled");
      });
      on(component, "fb:carb-planner-export-success", event => {
        const plan = component._lastPlan;
        if (!plan || plan.status === "error") return;
        track("carb_planner_pdf_downloaded", {
          action: event.detail?.action || "download",
          result_type: plan.status,
          sport: plan.input.sport,
          context: plan.input.context,
          duration_band: durationBand(plan.input.durationMinutes),
          expert_used: plan.input.expertEnabled
        });
      });
      on(component, "click", event => {
        const packageLink = event.target.closest?.("[data-test-package-role]");
        if (packageLink && component.contains(packageLink)) {
          const plan = component._lastPlan;
          track("carb_planner_test_package_clicked", {
            package_role: packageLink.dataset.testPackageRole || "unknown",
            product_handle: packageLink.dataset.testPackageHandle || "unknown",
            position: Number(packageLink.dataset.testPackagePosition) || 0,
            result_type: plan?.status || "unknown",
            sport: plan?.input?.sport || "unknown",
            context: plan?.input?.context || "unknown",
            intensity: plan?.input?.intensity || "unknown",
            duration_band: plan?.input?.durationMinutes ? durationBand(plan.input.durationMinutes) : "unknown",
            product_mode: plan?.formats?.productFormatMode || "unknown",
            section_id: sectionId
          });
          return;
        }
        const link = event.target.closest?.("[data-product-category]");
        if (!link || !component.contains(link)) return;
        const plan = component._lastPlan;
        track("carb_planner_category_clicked", {
          category: link.dataset.productCategory || "unknown",
          result_type: plan?.status || "unknown",
          sport: plan?.input?.sport || "unknown",
          duration_band: plan?.input?.durationMinutes ? durationBand(plan.input.durationMinutes) : "unknown"
        });
      });
      this._viewedResults = new Set();
      if ("IntersectionObserver" in window) {
        this._resultObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting) || !component._lastPlan || component._lastPlan.status === "error") return;
          const plan = component._lastPlan;
          const key = [plan.status, plan.input.sport, plan.input.context, plan.input.intensity, durationBand(plan.input.durationMinutes), plan.input.conditions, plan.input.toleranceBand, plan.input.expertEnabled, plan.formats.productFormatMode].join(":");
          if (component._viewedResults.has(key)) return;
          component._viewedResults.add(key);
          track("carb_planner_result_viewed", {
            result_type: plan.status,
            sport: plan.input.sport,
            context: plan.input.context,
            intensity: plan.input.intensity,
            duration_band: durationBand(plan.input.durationMinutes),
            conditions: plan.input.conditions,
            tolerance_band: plan.input.toleranceBand,
            expert_used: plan.input.expertEnabled,
            product_mode: plan.formats.productFormatMode
          });
        }, { threshold: 0.35 });
        this._resultObserver.observe($("result"));
      }

      applySportCap();
      syncExpertUi();
      showStep(1, false);
    }

    disconnectedCallback() {
      this._abortController?.abort();
      this._resultObserver?.disconnect();
      this._abortController = null;
      this._resultObserver = null;
      this._initialized = false;
    }
  }

  if (!customElements.get("fuelbox-carb-planner")) {
    customElements.define("fuelbox-carb-planner", FuelboxCarbPlanner);
  }
})();
